const Request = require('./BaseRequest')
const EventGraph = require('../graph/EventGraph')

module.exports = class EventRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new EventGraph(this.apiDomain)
    }

    swrClientEvents(accountId, optional={ privacy:1 })
    {
        let args = {accountId: accountId, ...optional}
        let { type, query } = this.graph.clientEventsQuery(['id', 'type', 'title', 'description', 'date_start', 'date_end', 'image', 'thumbnail', 'url'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }
    
    swrOrganizationEvents(optional={ privacy:1, tags: ['Hub Site'] })
    {
        let userId = optional.userId ? optional.userId : "";
        let args = {...optional}
        let { type, query } = this.graph.organizationEventsQuery(['id', 'type', 'title', 'tagline', 'description', 'date_start', 'date_end', 'client_date(userId:"'+userId+'")', 'image', 'thumbnail', 'url'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }
}